import { memo } from 'react';
import { useAsync } from 'react-use';
import { ArrayUtils } from '@zmedia/bm-soccer-ui/utils';
import { TournamentService } from '@zmedia/bm-soccer-ui/service/TournamentService';
import { Element, Icon } from '@zmedia/bm-soccer-ui/components';
import { StatsPlayer } from '@zmedia/bm-soccer-ui/modules/tournament/views/statistic/components';
import { URL_SOCCER_PAGE } from '@zmedia/bm-soccer-ui/modules/shared';
import { TitleWrap } from '@zmedia/bm-soccer-ui/modules/shared/components/TitleWrap';
import styles from './style.module.scss';

function TopPlayer(props: any) {
    const { id, seasonId, path } = props;
    let items = props.items || [];

    if (ArrayUtils.isEmpty(items)) {
        const state = useAsync(
            () =>
                TournamentService.getRankingDetail({
                    seasonId: seasonId,
                    tournamentId: id,
                    type: 1,
                }),
            [seasonId, id]
        );

        const data = state.value?.data || {};
        items = data.items || [];
    }

    if (ArrayUtils.isEmpty(items)) {
        return null;
    }

    return (
        <Element className={styles['top-player-sidebar']}>
            <Element className={styles['stats-container']}>
                <TitleWrap
                    link={`${URL_SOCCER_PAGE.SUBPATH}thong-ke-${path}?seasonId=${seasonId}`}
                    title={'Vua phá lưới'}
                >
                    <Icon icon="forward-2" />
                </TitleWrap>
                <StatsPlayer items={items} />
            </Element>
        </Element>
    );
}

export default memo(TopPlayer);
